import axios from "axios";
import { BASE_URL } from "./constant";

const API_BASE = process.env.REACT_APP_API_BASE || BASE_URL;

export async function createSerializedCollection(formData, onUploadProgress) {
  const response = await axios.post(`${API_BASE}/api/catalog-admin/collections`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });

  return response.data;
}

export async function createSeason(payload) {
  const response = await axios.post(`${API_BASE}/api/catalog-admin/seasons`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
}

export async function updateSeasonDetails(seasonId, payload) {
  const response = await axios.put(`${API_BASE}/api/catalog-admin/seasons/${seasonId}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
}

export async function uploadEpisode(contentId, seasonId, formData, onUploadProgress) {
  const response = await axios.post(`${API_BASE}/api/catalog-admin/episodes/${contentId}/${seasonId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });

  return response.data;
}

export async function fetchSerializedCollections(type) {
  const response = await axios.get(`${API_BASE}/api/catalog-admin/collections/${type}`);
  return response.data.data || [];
}

export async function fetchSeasonsBySeries(seriesId) {
  const response = await axios.get(`${API_BASE}/api/catalog-admin/seasons/series/${seriesId}`);
  return response.data.data || [];
}

export async function fetchEpisodesBySeason(seasonId) {
  const response = await axios.get(`${API_BASE}/api/catalog-admin/episodes/season/${seasonId}`);
  return response.data.data || [];
}

export async function fetchEpisodeStudioPending() {
  const response = await axios.get(`${API_BASE}/api/episode-studio/pending`);
  return response.data.data || [];
}

export async function fetchEpisodeStudioDetail(episodeId) {
  const response = await axios.get(`${API_BASE}/api/episode-studio/${episodeId}`);
  return response.data.data || null;
}

export async function fetchPublicationCollections(bucket = "unpublished", type = null) {
  const response = await axios.get(`${API_BASE}/api/catalog-admin/publication/collections`, {
    params: {
      bucket,
      type,
    },
  });
  console.log("response catalogue : ", response.data.data);

  return response.data.data || [];
}

export async function fetchSeriesPublicationTree(seriesId) {
  const response = await axios.get(`${API_BASE}/api/catalog-admin/publication/series/${seriesId}`);
  return response.data.data || null;
}

export async function updatePublicationContent(contentId, statutpub) {
  const response = await axios.put(
    `${API_BASE}/api/catalog-admin/publication/content/${contentId}`,
    { statutpub },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data.data || null;
}

export async function updatePublicationEpisode(episodeId, statutpub) {
  const response = await axios.put(
    `${API_BASE}/api/catalog-admin/publication/episode/${episodeId}`,
    { statutpub },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data.data || null;
}

export async function fetchCatalogContentDetail(contentId) {
  const response = await axios.get(`${API_BASE}/api/catalog-admin/content/${contentId}`);
  return response.data.data || null;
}

export async function updateCatalogContent(contentId, formData) {
  const response = await axios.put(`${API_BASE}/api/catalog-admin/content/${contentId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data.data || null;
}

export async function fetchEpisodeDetailForEdit(episodeId) {
  const response = await axios.get(`${API_BASE}/api/catalog-admin/episodes/detail/${episodeId}`);
  return response.data.data || null;
}

export async function updateEpisodeDetail(episodeId, payload) {
  const response = await axios.put(`${API_BASE}/api/catalog-admin/episodes/detail/${episodeId}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data.data || null;
}

export async function fetchCaptionTracks(targetType, targetId) {
  const safeTargetType = targetType === "episode" ? "episode" : "content";
  const response = await axios.get(`${API_BASE}/api/catalog-admin/captions/${safeTargetType}/${targetId}`);
  return response.data.data || [];
}

export async function uploadCaptionTrack(targetType, targetId, formData) {
  const safeTargetType = targetType === "episode" ? "episode" : "content";
  const response = await axios.post(`${API_BASE}/api/catalog-admin/captions/${safeTargetType}/${targetId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data.data || [];
}

export async function updateCaptionDetails(captionId, payload) {
  const response = await axios.put(`${API_BASE}/api/catalog-admin/captions/${captionId}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
}

export async function deleteCaptionDetails(captionId) {
  const response = await axios.delete(`${API_BASE}/api/catalog-admin/captions/${captionId}`);
  return response.data;
}
